import { videoContentUrl, contentUrl } from '../../api'

export const DERMATITIS_VIDEOS = {
  name: 'Atopic Dermatitis Screen',
  title: 'ATOPIC DERMATITIS',
  overlay: {
    type: "ClickableImage",
    options: {
      src: `${contentUrl}/images/clinical-trial-study-designs.png`,
      srcMobile: `${contentUrl}/images/clinical-trial-study-designs-mobile.png`,
    },
  },
  content: [
    {
      menuTemplate: 'SINGLE',
      menuName: 'MECHANISM OF ACTION (MOA)',
      content: {
        contentTemplate: 'VIDEO',
        content: {
          src: `${videoContentUrl}/atopic-dermatitis-moa.mp4`,
          poster: `${videoContentUrl}/posters/atopic-dermatitis-moa-poster.png`,
        },
      },
    },
    {
      menuTemplate: 'DROPDOWN',
      menuName: 'REAL PATIENT STORIES',
      subItems: [
        {
          subMenuName: 'BRITTON-AVID HIKER <br />MODERATE DISEASE',
          contentTemplate: 'VIDEO',
          content: {
            src: `${videoContentUrl}/patient-story-britton.mp4`,
            poster: `${videoContentUrl}/posters/patient-story-britton-poster.png`,
          },
        },
        {
          subMenuName: 'ANNIE-HIGH SCHOOL <br />STUDENT ATHLETE <br />SEVERE DISEASE',
          contentTemplate: 'VIDEO',
          content: {
            src: `${videoContentUrl}/patient-story-annie.mp4`,
            poster: `${videoContentUrl}/posters/patient-story-annie-poster.png`,
          },
        },
        {
          subMenuName: 'RACHEL-NATURE LOVER <br />SEVERE DISEASE',
          contentTemplate: 'VIDEO',
          content: {
            src: `${videoContentUrl}/patient-story-rachel.mp4`,
            poster: `${videoContentUrl}/posters/patient-story-rachel-poster.png`,
          },
        },
      ],
    },
    {
      menuTemplate: 'DROPDOWN',
      menuName: 'REAL PHYSICIAN STORIES',
      subItems: [
        {
          subMenuName: 'DR NEAL BHATIA,<br/>DERMATOLOGIST',
          contentTemplate: 'VIDEO',
          content: {
            src: `${videoContentUrl}/dermatologist-dr-neil-bhatia.mp4`,
            poster: `${videoContentUrl}/posters/dermatologist-dr-neil-bhatia-poster.png`,
          },
        },
        {
          subMenuName: 'DR JENNIFER SOUNG,<br/>DERMATOLOGIST',
          contentTemplate: 'VIDEO',
          content: {
            src: `${videoContentUrl}/dermatologist-dr-jennifer-soung.mp4`,
            poster: `${videoContentUrl}/posters/dermatologist-dr-jennifer-soung-poster.png`,
          },
        },
        {
          subMenuName: 'DR AMY SPIZUOCO,<br/>DERMATOLOGIST',
          contentTemplate: 'VIDEO',
          content: {
            src: `${videoContentUrl}/dermatologist-dr-amy-spizuoco.mp4`,
            poster: `${videoContentUrl}/posters/dermatologist-dr-amy-spizuoco-poster.png`,
          },
        },
      ],
    },
    {
      menuTemplate: 'SINGLE',
      menuName: 'CLINICAL PROFILE',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          src: `${contentUrl}/images/clinical-trial-study-designs.png`,
          srcMobile: `${contentUrl}/images/clinical-trial-study-designs-mobile.png`,
          alt: "StudyDesigns",
        },
      },
    },
  ],
}
